var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9727 25.4388L27.0977 22.0638C26.7613 21.9205 26.3874 21.8903 26.0324 21.9778C25.6773 22.0653 25.3603 22.2657 25.129 22.549L21.6415 26.8099C16.1682 24.2293 11.7634 19.8246 9.18281 14.3513L13.4437 10.8638C13.7276 10.6329 13.9285 10.3159 14.016 9.96064C14.1036 9.60541 14.073 9.23132 13.9289 8.89502L10.5539 1.02002C10.3958 0.657499 10.1161 0.361509 9.76314 0.183093C9.41016 0.00467774 9.00598 -0.0449809 8.62031 0.0426803L1.30781 1.73018C0.935978 1.81604 0.604227 2.02541 0.366704 2.3241C0.129182 2.62279 -8.56554e-05 2.99317 4.25827e-08 3.37479C4.25827e-08 21.4099 14.618 35.9998 32.625 35.9998C33.0067 36 33.3773 35.8708 33.6761 35.6333C33.9749 35.3958 34.1844 35.0639 34.2703 34.692L35.9578 27.3795C36.0449 26.9919 35.9942 26.5861 35.8144 26.2319C35.6346 25.8777 35.337 25.5973 34.9727 25.4388Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAlt);
export default __webpack_public_path__ + "static/media/phone-alt.07d6b08c784a108e782cd1bfdfdc2ed3.svg";
export { ForwardRef as ReactComponent };